import PropertyDetailKos from './PropertyDetailKos.vue';

export default PropertyDetailKos;